
const initialState = {
  routeData: null,
  allRoutes: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_DATA': {
      // console.log('LOAD DATA') 
      return { ...state, routeData: action.payload };
    }
    case 'ALL_ROUTES': {
      return { ...state, allRoutes: action.payload };
    }


    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/reducers/mapReducer.js